import { LineItem } from 'shared/types/cart';
import ColoredTag from 'components/commercetools-ui/molecules/product-tile/components/tag';
import { PickupItem } from './OrderItemsSection';

type Text = {
  extraPages?: string;
  detailsCTAmediaClip?: string;
};

interface Props {
  isChild: boolean;
  item: PickupItem;
  childLineItems: LineItem[];
  idx: number;
  index?: number;
  text?: Text;
}

const MediaClipElement = ({ isChild, item, childLineItems, idx, index, text }: Props) => {
  return isChild ? (
    <div
      className="col-start-2 col-end-4 row-start-3 row-end-4 gap-[1.25rem] py-[0.5rem]"
      data-ffid={`ctr-item-children-container-${index}-${idx}`}
    >
      <div
        className="flex w-fit flex-row text-left text-sm lg:text-base"
        data-ffid={`text-item-details-text-mediaclip-${index}-${idx}`}
      >
        {text?.detailsCTAmediaClip}
      </div>

      {isChild && (
        <ul className="col-start-2 col-end-6 ml-15 mt-2 list-disc" data-ffid={`lst-item-children-${index}-${idx}`}>
          {[item, ...childLineItems]?.map((child, i) => {
            return (
              <li
                key={(child?.lineItemId ?? '') + i}
                className="flex flex-col items-start gap-y-2 md:flex-row md:items-center md:gap-x-4"
              >
                <p
                  className="text-14 text-[#666666] lg:text-16"
                  data-ffid={`lbl-order-items-shiplist-attributes-${index}-${idx}-${i}`}
                >
                  {i == 0 ? item?.attributes : text?.extraPages}
                </p>
                <ColoredTag isSale={item?.isSale} inline />
              </li>
            );
          })}
        </ul>
      )}
    </div>
  ) : (
    <div className="flex flex-col items-start gap-y-2 md:flex-row md:items-center md:gap-x-4">
      <p
        className="text-14 text-[#666666] lg:text-16"
        data-ffid={`lbl-order-items-shiplist-attributes-${index}-${idx}`}
      >
        {item?.attributes}
      </p>
      <ColoredTag isSale={item.isSale} inline />
    </div>
  );
};

export default MediaClipElement;
